import { useQuery } from 'react-query'

import { QueryKeys } from 'constants/queries'
import { getArtistById } from 'api/artists'
import { GetArtistByIdResponse } from 'models/artists/ApiModels'
import { ArtistByIdInfo } from 'models/artists/EntityModels'
import { deserializeArtist } from 'serializers/artists'

const useGetArtist = (id: number) => useQuery([QueryKeys.ARTIST, { id }], getArtistById, {
  select: (data: GetArtistByIdResponse):ArtistByIdInfo => deserializeArtist(data)
})

export default useGetArtist
